import React from "react";
import { Palette, FlaskConical, Globe, BookOpen } from "lucide-react";
import { Link } from "@/components/common/Link";
import { cn } from "@/lib/utils";
const disciplines = [{
  id: "craftsmanship",
  title: "Craftsmanship",
  description: "The 'How': Precision-engineered roofing systems built with industrial-grade materials and expert techniques.",
  icon: Palette,
  bgColor: "bg-card",
  iconColor: "text-primary/5",
  href: "/OurCraftsmanshipPage"
}, {
  id: "reliability",
  title: "Reliability",
  description: "The 'When': Dependable scheduling and long-term structural integrity that stands up to the harshest elements.",
  icon: FlaskConical,
  bgColor: "bg-card",
  iconColor: "text-chart-2/10",
  href: "/RMStoryPage"
}, {
  id: "attention",
  title: "Attention to Detail",
  description: "The 'Why': Every seal, shingle, and layer is inspected to ensure a flawless, waterproof finish for your property.",
  icon: Globe,
  bgColor: "bg-card",
  iconColor: "text-chart-3/10",
  href: "/GetQuotePage"
}, {
  id: "durability",
  title: "Total Protection",
  description: "Integrated solutions combining insulation, weatherproofing, and roofing for ultimate building performance.",
  icon: BookOpen,
  bgColor: "bg-card",
  iconColor: "text-chart-4/10",
  href: "/OurCraftsmanshipPage"
}];
export default function ExploreByDiscipline() {
  return <section data-section-id="224170" id="our-commitment" className="py-20 md:py-32 bg-background dark">
      <div className="container mx-auto px-4 md:px-6">
        <div className="max-w-3xl mb-12 md:mb-16">
          <h2 className="font-default text-3xl md:text-5xl font-extrabold tracking-tighter text-foreground mb-4 uppercase">
            Our Commitment
          </h2>
          <p className="text-lg text-muted-foreground font-sans">
            Delivering architectural precision through high-quality roofing and waterproofing solutions for every structure.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {disciplines.map((item, i) => <Link key={item.id} to={item.href} data-index={i} className={cn("group relative overflow-hidden rounded-lg border border-border min-h-[320px] flex flex-col justify-end p-8 transition-all duration-300 hover:shadow-4xl hover:-translate-y-1", item.bgColor)}>
              {}
              <div className="absolute -right-8 -bottom-8 z-0 pointer-events-none">
                <item.icon className={cn("w-64 h-64 transition-transform duration-700 ease-out group-hover:scale-110", item.iconColor)} strokeWidth={1} />
              </div>

              {}
              <div className="relative z-10">
                <h3 className="font-default text-3xl font-extrabold text-foreground transition-transform duration-300 ease-out group-hover:-translate-y-2 tracking-tighter uppercase">
                  {item.title}
                </h3>
                <div className="grid grid-rows-[0fr] transition-[grid-template-rows] duration-300 ease-out group-hover:grid-rows-[1fr]">
                  <div className="overflow-hidden">
                    <p className="text-muted-foreground font-sans text-base line-clamp-2 opacity-0 transition-opacity duration-300 delay-100 group-hover:opacity-100 pt-2">
                      {item.description}
                    </p>
                  </div>
                </div>
              </div>
            </Link>)}
        </div>
      </div>
    </section>;
}